import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function saveUserAddressBuilder(apiClient: AxiosInstance) {
  return async function saveUserAddress(payload: any): Promise<any> {
    const response = await apiClient.post(`/accounts/user-addresses/`, payload);
    return response.data;
  };
}
